import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ClassRoomDetails from "ClassRoom/routes/ClassRoomDetails";

export default store => ({
  path: "assessments",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "course-gradebook" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [ClassRoomDetails(store)],
});
